import { FunctionComponent } from 'react';
import ImagesUtils from '../../utils/images';

type Props = {
  active?: boolean;
};

const UpgradeTrainer: FunctionComponent<Props> = ({ active }) => {
  const image = ImagesUtils.getUpgradeImage(active);

  return (
    <img src={image} alt={`UpgradeTrainer${active ? 'Active' : 'Inactive'}`} />
  );
};

export default UpgradeTrainer;
